import ChartRenderer from './ChartRenderer';

const SectionRenderer = ({ section }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${section.columns}, 1fr)`,
        gap: 20,
      }}
    >
      {section.charts.map(chart => (
        <div
          key={chart.id}
          style={{
            gridColumn: `span ${chart.span || 1}`,
            background: '#fff',
            borderRadius: 12,
            padding: 20,
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            maxHeight: 450,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative'
          }}
        >
          <ChartRenderer chart={chart} />
        </div>
      ))}
    </div>
  );
};

export default SectionRenderer;